import { useRef, useEffect, useState, useMemo } from "react";
import "./Event.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import BadgePercent from "../../assets/icons/badge-percent.png";
import TV from "../../assets/img/tv-251854.jpg";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import ApiService from "../../components/Api_services";
import { useParams, Link } from "react-router-dom";
import FallbackImg from "../../components/FallbackImg";

const ITEMS_PER_PAGE = 20;

function getPagination(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);
    if (current > 4) pages.push("...");
    let start, end;
    if (current <= 4) {
      start = 2;
      end = 5;
    } else if (current >= total - 3) {
      start = total - 4;
      end = total - 1;
    } else {
      start = current - 1;
      end = current + 1;
    }
    for (let i = start; i <= end; i++) {
      if (i > 1 && i < total) pages.push(i);
    }
    if (current < total - 3) pages.push("...");
    pages.push(total);
  }
  return pages;
}

const Eventv2 = () => {
  // const sliderRef = useRef(null);
  const { event_id } = useParams();
  const prevEventIdRef = useRef(event_id);
  const [products, setProducts] = useState([]);
  const [eventImage, setEventImage] = useState("");
  const isLoggedIn = !!localStorage.getItem("access_token");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // const scrollLeft = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.scrollBy({ left: -250, behavior: "smooth" });
  //   }
  // };

  // const scrollRight = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.scrollBy({ left: 250, behavior: "smooth" });
  //   }
  // };

  useEffect(() => {
    if (!event_id) return;

    const isNewEvent = prevEventIdRef.current !== event_id;
    if (isNewEvent) {
      prevEventIdRef.current = event_id;
      if (currentPage !== 1) {
        setCurrentPage(1);
        return;
      }
    }

    const fetchEventProducts = async () => {
      const fetchEventId = event_id;
      const fetchPage = currentPage;
      setLoading(true);
      try {
        const offset = (fetchPage - 1) * ITEMS_PER_PAGE;
        const res = await ApiService.getPromotionEvent(
          fetchEventId,
          offset,
          ITEMS_PER_PAGE,
        );
        if (
          fetchEventId !== prevEventIdRef.current ||
          fetchPage !== currentPage
        ) {
          return;
        }
        setProducts(res.data?.item_list || []);
        if (fetchPage === 1) {
          setEventImage(res.data?.event_image || "");
        }
        const pagination = res.data?.pagination;
        setTotalPages(pagination?.total_pages || 0);
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        if (
          fetchEventId === prevEventIdRef.current &&
          fetchPage === currentPage
        ) {
          setLoading(false);
        }
      }
    };

    fetchEventProducts();
  }, [event_id, currentPage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [event_id]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  // const getProductPricing = (item, isLoggedIn) => {
  //   if (isLoggedIn) {
  //     const brandPrice = parseFloat(item.brand_price || 0);

  //     // Find promotion_type === 3 (Item Discount)
  //     let itemDiscountPromo = null;
  //     if (Array.isArray(item.promotions)) {
  //       itemDiscountPromo = item.promotions.find(
  //         (promo) => String(promo.promotion_type) === "3"
  //       );
  //     }
  //     const itemDiscountPrice = itemDiscountPromo
  //       ? parseFloat(itemDiscountPromo.brand_price || 0)
  //       : 0;

  //     // 如果 brand_price 为空或为 0，则用 rcp 逻辑
  //     if (!brandPrice) {
  //       const rcp = parseFloat(item.rcp || 0);
  //       const rcpOffer = parseFloat(item.rcp_offer || 0);

  //       let displayPrice = rcp;
  //       let originalPrice = null;
  //       let discountPercent = 0;

  //       if (rcpOffer > 0 && rcpOffer < rcp) {
  //         displayPrice = rcpOffer;
  //         originalPrice = rcp;
  //         discountPercent = Math.round(((rcp - rcpOffer) / rcp) * 100);
  //       }

  //       return {
  //         displayPrice,
  //         originalPrice,
  //         discountPercent,
  //       };
  //     }

  //     // 正常 brand_price 逻辑
  //     let displayPrice = brandPrice;
  //     let originalPrice = null;
  //     let discountPercent = 0;

  //     if (itemDiscountPrice > 0 && itemDiscountPrice < brandPrice) {
  //       displayPrice = itemDiscountPrice;
  //       originalPrice = brandPrice;
  //       discountPercent = Math.round(
  //         ((brandPrice - itemDiscountPrice) / brandPrice) * 100
  //       );
  //     }

  //     return {
  //       displayPrice,
  //       originalPrice,
  //       discountPercent,
  //     };
  //   } else {
  //     const rcp = parseFloat(item.rcp || 0);
  //     let displayPrice = rcp;
  //     let originalPrice = null;
  //     let discountPercent = 0;

  //     return {
  //       displayPrice,
  //       originalPrice,
  //       discountPercent,
  //     };
  //   }
  // };
  const getProductPricing = (item, isLoggedIn) => {
    const isPlaceholder = (val) => val && isNaN(parseFloat(val));
    if (isPlaceholder(item.lowest_price) || isPlaceholder(item.brand_price)) {
      return {
        displayPrice: item.lowest_price ?? item.brand_price,
        originalPrice: null,
        discountPercent: 0,
        isPlaceholder: true,
      };
    }

    const lowestPrice = parseFloat(item.lowest_price || 0);
    const brandPrice = parseFloat(item.brand_price || 0);

    if (lowestPrice > 0) {
      let discountPercent = 0;
      if (brandPrice > 0 && lowestPrice < brandPrice) {
        discountPercent = Math.round(
          ((brandPrice - lowestPrice) / brandPrice) * 100,
        );
      }
      return {
        displayPrice: lowestPrice,
        originalPrice:
          brandPrice > 0 && lowestPrice < brandPrice ? brandPrice : null,
        discountPercent,
      };
    }

    // 优先查找 type 3 promotion
    const type3Promo = (item.promotions || []).find(
      (promo) => String(promo.promotion_type) === "3",
    );
    if (type3Promo && type3Promo.brand_price) {
      const brandPrice = parseFloat(item.brand_price || 0);
      const promoPrice = parseFloat(type3Promo.brand_price || 0);
      let discountPercent = 0;
      if (promoPrice > 0 && promoPrice < brandPrice) {
        discountPercent = Math.round(
          ((brandPrice - promoPrice) / brandPrice) * 100,
        );
      }
      return {
        displayPrice: promoPrice,
        originalPrice: brandPrice,
        discountPercent,
      };
    }

    // 其它类型按原有逻辑
    if (isLoggedIn) {
      const brandPrice = parseFloat(item.brand_price || 0);
      const promotionPrice = parseFloat(item.promotion_price || 0);

      let displayPrice = brandPrice;
      let originalPrice = null;
      let discountPercent = 0;

      if (promotionPrice > 0 && promotionPrice < brandPrice) {
        displayPrice = promotionPrice;
        originalPrice = brandPrice;
        discountPercent = Math.round(
          ((brandPrice - promotionPrice) / brandPrice) * 100,
        );
      }

      return {
        displayPrice,
        originalPrice,
        discountPercent,
      };
    } else {
      const rcp = parseFloat(item.rcp || 0);
      return {
        displayPrice: rcp,
        originalPrice: null,
        discountPercent: 0,
      };
    }
  };
  const promotionTypes = useMemo(() => {
    if (!products || products.length === 0) return [];
    // Flatten all promotion_type from all products' promotions array
    const types = products.flatMap((item) =>
      Array.isArray(item.promotions)
        ? item.promotions.map((promo) => promo.promotion_type)
        : [],
    );
    return [...new Set(types)];
  }, [products]);

  const getPromotionTypeLabel = (type) => {
    switch (String(type)) {
      case "2":
        return "Free Gift";
      case "3":
        return "Item Discount";
      case "4":
        return "Quantity Offer";
      case "5":
        return "PWP";
      case "6":
        return "Display Discount";
    }
  };

  const getPromoIcon = (tag) => {
    if (tag.toLowerCase().includes("free gift")) {
      return <FontAwesomeIcon icon={faGift} />;
    }
    if (tag.toLowerCase().includes("discount")) {
      return (
        <FallbackImg
          src={BadgePercent}
          alt="badgepercent"
          width="13"
          height="13"
          style={{
            filter:
              "invert(23%) sepia(13%) saturate(1162%) hue-rotate(54deg) brightness(93%) contrast(92%)",
          }}
        />
      );
    }
    if (tag.toLowerCase().includes("quantity offer")) {
      return <FontAwesomeIcon icon={faGift} />;
    }
    if (tag.toLowerCase().includes("pwp")) {
      return (
        <FallbackImg
          src={BadgePercent}
          alt="badgepercent"
          width="13"
          height="13"
          style={{
            filter:
              "invert(23%) sepia(13%) saturate(1162%) hue-rotate(54deg) brightness(93%) contrast(92%)",
          }}
        />
      );
    }
    return null;
  };

  const getProductLink = (item) => {
    if (
      typeof item.item_id === "string" &&
      item.item_id.startsWith("is_package_")
    ) {
      const parts = item.item_id.split("_"); // ["is", "package", "13", "1"]
      const packageId = parts[2];
      const packageType = parts[3];

      if (packageType === "1") return `/grouppackagedetail/${packageId}`;
      if (packageType === "0") return `/packageproductdetail/${packageId}`;
    }

    if (item.package_id != null && item.package_id !== "") {
      return `/productdetail/${item.id}/?isBundle=1&bundleId=${item.package_id}`;
    }

    return `/productdetail/${item.id}`;
  };

  return (
    <div className="event_v2">
      <div className="event-content_v2">
        {!loading && eventImage && (
          <div className="event-banner_v2">
            <FallbackImg
              src={eventImage}
              alt="eventimg"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "fill",
              }}
            />
          </div>
        )}

        <div className="event-products-section_v2">
          <div className="event-product-list_v2">
            {products.length > 0 ? (
              products.map((item) => {
                const rawCategories = (item.selling_point || "")
                  .split("|")
                  .map((s) => s.trim())
                  .filter(Boolean);
                const categoryLines = rawCategories.slice(0, 3);
                while (categoryLines.length < 3) categoryLines.push("");

                const isPackage =
                  typeof item.item_id === "string" &&
                  item.item_id.startsWith("is_package_");

                const toNumber = (v) => {
                  if (v === undefined || v === null) return null;
                  const n = parseFloat(v);
                  return Number.isFinite(n) ? n : null;
                };

                const lowestNum = toNumber(item.lowest_price);
                const highestNum = toNumber(item.highest_price);
                const brandNum = toNumber(item.brand_price);
                const brandOfferNum = toNumber(item.brand_price_offer);
                const rcpNum = toNumber(item.rcp);
                const rcpOfferNum = toNumber(item.rcp_offer);

                const isPriceRange =
                  lowestNum !== null &&
                  highestNum !== null &&
                  highestNum > lowestNum;

                let mainPrice, oldPrice, showOldPrice;

                if (isPriceRange) {
                  mainPrice = lowestNum;
                  oldPrice = null;
                  showOldPrice = false;
                } else {
                  const chosen =
                    (lowestNum !== null && lowestNum > 0 && lowestNum) ||
                    (brandOfferNum !== null &&
                      brandOfferNum > 0 &&
                      brandOfferNum) ||
                    (brandNum !== null && brandNum > 0 && brandNum) ||
                    (rcpOfferNum !== null && rcpOfferNum > 0 && rcpOfferNum) ||
                    (rcpNum !== null && rcpNum > 0 && rcpNum) ||
                    null;

                  mainPrice = chosen;

                  if (
                    brandNum !== null &&
                    chosen !== null &&
                    brandNum > chosen
                  ) {
                    oldPrice = brandNum;
                    showOldPrice = true;
                  } else {
                    oldPrice = null;
                    showOldPrice = false;
                  }
                }

                let displayPriceStr = null;
                if (isPriceRange) {
                  displayPriceStr = formatCurrency(lowestNum);
                } else if (mainPrice !== null && mainPrice > 0) {
                  displayPriceStr = formatCurrency(mainPrice);
                }

                // backend-provided discount fields
                const backendBP =
                  item.discount_percent_bp || item.discount_percent || "";
                const backendRCP =
                  item.discount_percent_rcp || item.display_discount_pct || "";

                let discountPercent, showDiscount;

                if (isPriceRange) {
                  const discountDisplay = backendBP || backendRCP || null;
                  const normalizedDiscount =
                    discountDisplay && String(discountDisplay).trim() !== "0%"
                      ? discountDisplay
                      : null;
                  showDiscount = !!normalizedDiscount;
                  discountPercent = normalizedDiscount;
                } else {
                  if (
                    brandNum !== null &&
                    mainPrice !== null &&
                    brandNum > mainPrice
                  ) {
                    const calculatedDiscount = Math.round(
                      ((brandNum - mainPrice) / brandNum) * 100,
                    );
                    discountPercent =
                      calculatedDiscount > 0 ? `-${calculatedDiscount}%` : null;
                    showDiscount = calculatedDiscount > 0;
                  } else {
                    discountPercent = null;
                    showDiscount = false;
                  }
                  const computedDiscount = discountPercent || null;
                  const discountDisplay =
                    backendBP || backendRCP || computedDiscount || null;
                  const normalizedDiscount =
                    discountDisplay && String(discountDisplay).trim() !== "0%"
                      ? discountDisplay
                      : null;
                  showDiscount = !!normalizedDiscount;
                  discountPercent = normalizedDiscount;
                }

                // promo tags
                const promoTags = item.promo_name
                  ? item.promo_name
                      .split(",")
                      .map((tag) => tag.trim())
                      .filter(Boolean)
                  : [];

                const isQuantityOffer = (tag) =>
                  /^buy\s*\d+\s*(free|get)\s*\d+/i.test(tag) ||
                  /^buy\s*\d+\s*(free|get)\s*\d+\s*discount/i.test(tag);

                let hasQuantityOffer = promoTags.some(isQuantityOffer);
                let otherTags = promoTags.filter(
                  (tag) => !isQuantityOffer(tag),
                );

                if (hasQuantityOffer) {
                  otherTags = ["Quantity Offer", ...otherTags];
                }

                const sortedTags = [
                  ...otherTags.filter(
                    (tag) =>
                      tag.toLowerCase() !== "item discount" &&
                      tag.toLowerCase() !== "discount",
                  ),
                  ...otherTags.filter(
                    (tag) =>
                      tag.toLowerCase() === "item discount" ||
                      tag.toLowerCase() === "discount",
                  ),
                ];

                return (
                  <Link
                    to={getProductLink(item)}
                    key={item.id}
                    style={{ textDecoration: "none", color: "inherit" }}
                    className="event-product-card_v2"
                  >
                    <div className="pl-product-internal_v2">
                      {Array.isArray(item.promotions) &&
                        item.promotions.length > 0 && (
                          <div className="promo-tag-overlay_v2">
                            <span className="promo-tag-text_v2">Promo</span>
                          </div>
                        )}
                      {showDiscount && discountPercent && (
                        <div className="discount-pill_v2">
                          {discountPercent}
                        </div>
                      )}

                      <div className="product-image-wrapper_v2">
                        <FallbackImg
                          src={item.thumb_url}
                          alt={item.item_code}
                        />
                      </div>

                      <div
                        className={`product-info_v2 ${isPackage ? "" : " standard"}`}
                      >
                        <div className="productname_v2">{item.item_code}</div>
                        <div className="product-card-descrip-container_v2">
                          <div
                            className="description_v2"
                            title={item.nick_name}
                          >
                            {item.nick_name}
                          </div>
                        </div>

                        {!isPackage && (
                          <div
                            className="productcategory_v2"
                            title={item.selling_point}
                          >
                            <div className="productcategory-item_v2">
                              {categoryLines[0]}
                            </div>
                            <div className="productcategory-item_v2">
                              {categoryLines[1]}
                            </div>
                            <div className="productcategory-item_v2">
                              {categoryLines[2]}
                            </div>
                          </div>
                        )}

                        {isPackage ? (
                          <div className="package-price-container_v2">
                            <span className="package-price-label_v2">
                              Starting from
                            </span>
                            <span className="package-price_v2">
                              {displayPriceStr}++
                            </span>
                            <span className="package-price-note_v2">
                              Pricing varies by selection
                            </span>
                          </div>
                        ) : displayPriceStr !== null &&
                          displayPriceStr !== "" ? (
                          <div className="price-container_v2">
                            <div className="price_v2">
                              <span className="price-sub_v2">FROM</span> RM{" "}
                              {displayPriceStr}
                            </div>
                          </div>
                        ) : (
                          <div style={{ minHeight: "28px" }}></div>
                        )}
                      </div>
                    </div>
                  </Link>
                );
              })
            ) : products.length === 0 && loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                Loading products...
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                No products found.
              </div>
            )}
          </div>

          {totalPages >= 1 && (
            <div className="pagination-modern_v2 event-pagination_v2">
              <button
                className="pagination-btn_v2"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <span className="prevnext-text_v2">Prev</span>
              </button>
              {getPagination(currentPage, totalPages).map((p, idx) =>
                p === "..." ? (
                  <span
                    key={`ellipsis-${idx}`}
                    className="pagination-ellipsis_v2"
                  >
                    ...
                  </span>
                ) : (
                  <button
                    key={`page-${p}-${idx}`}
                    className={`pagination-btn_v2${
                      currentPage === p ? " pagination-current_v2" : ""
                    }`}
                    onClick={() => handlePageChange(p)}
                    disabled={currentPage === p}
                  >
                    {p}
                  </button>
                ),
              )}
              <button
                className="pagination-btn_v2"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <span className="prevnext-text_v2">Next</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Eventv2;
